

export enum selectedViewEnam {
	MANUAL = "MANUAL",
	NEWCLIENT = "NEWCLIENT",
	ARXCLIENT = "ARXCLIENT",
	SECONDSEARCH = "SECONDSEARCH",
	SEARCH = "SEARCH"
}

